<template>
	<div id="cekTransaksi">
		<div class="cekTransaksi">
			<div class="container">
				<div class="row">
					<div class="col-12 p-md-0 mb-3">
						<div class="col-12 pt-3 pb-3 p-md-3 rounded background-white top-slider shadow d-md-flex">
							<div class="form-group p-0 pr-md-2 pl-md-3 color-mila col-12 col-md-4 col-lg-4 pt-2 pt-md-4">
								<input type="text" @keydown="removeAlert" v-model="code.data" class="form-control col-12 box-purple font-size-sm-10 f-lato" id="_kodeTransaksiCekStatus" placeholder="Kode Transaksi">
								<Alert empty v-if="code.msg" :content="code.msg"/>
							</div>
							<div class="form-group p-0 pr-md-2 pl-md-3 color-mila col-12 col-md-4 col-lg-5 pt-0 pt-md-4">
								<input type="text" @keydown="removeAlert" v-model="mobilephone.data" class="form-control col-12 box-purple font-size-sm-10 f-lato" id="_nomorHandphoneCekStatus" placeholder="Nomor Handphone">
								<Alert empty v-if="mobilephone.msg" :content="mobilephone.msg"/>
							</div>
							<div class="form-group p-0 col-12 col-md-4 col-lg-3 pl-md-3 pr-md-3 mb-1 mb-md-3">
								<button class="btn color-white background-button-template col-12 mt-md-4 rounded box-purple" type="button" @click="cekTransaksi">
									<i class="fa fa-search mr-2 font-size-10"></i><span class="font-size-12 font-size-sm-10">Cek Transaksi</span>
								</button>
							</div>
						</div>
					</div>
					<div class="col-12 p-md-0 mt-3">
						<div class="col-12 rounded background-white shadow pt-3 pb-3 mb-5">
							<div class="col-12 p-0 mt-3 color-mila font-bold pl-md-3">
								<h5 class="font-bold">Cek Status Transaksi</h5>
							</div>
							<div class="col-12 p-0 color-black mt-3 font-size-sm-9 text-justify pl-md-3">
								Harap diperhatikan fitur ini hanya untuk cek transaksi mitra baru. Pastikan kode transaksi dan nomor handphone sesuai bukti transaksi.
							</div>
							<div class="col-12" v-if="transactionDetail.code==400">
								<div class="col-12 mt-3 pt-3 pb-3 rounded">
									<div class="text-center">
										<div><img class="img-fluid" src="/assets/icon/no-data-found.svg" alt=""></div>
										<div class="pt-3 color-black">Transaksi tidak tersedia.</div>
									</div>
								</div>
							</div>
							<div v-if="$store.state.progressStatus == 'start' && transactionDetail.code!=200">
								<SkeletonDetail/>
							</div>
							<div v-if="transactionDetail.code==200">
								<StatusTransaksi />
							</div>
						</div>
					</div>
					<ml-partner-us ></ml-partner-us>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import MlPartnerUs from '@/components/MlPartnerUs.vue'
import SkeletonDetail from '@/components/Skeleton/SkeletonDetailTransaksi'
import { mapState, mapGetters, mapActions } from 'vuex'
import validator from 'validator'
import Alert from '@/components/Alert'
import StatusTransaksi from '@/views/public/StatusTransaksi'

export default {
	components:{
		MlPartnerUs, Alert , StatusTransaksi, SkeletonDetail
	},

	data(){
		return{
			pickUpAddress:'',
			param:'',
			icon:true,
			code:{
				data:'',
				msg:''
			},
			mobilephone:{
				data:'',
				msg:''
			},
			dataTransaksi:{
				code:'',
				data:''
			}
		}
	},

	computed:{
		...mapState('transaction', ['transactionDetail']),
		...mapGetters('auth', ['isAuth']),
	},

	methods:{
		...mapActions('transaction', ['getTransactionDetail']),
		removeAlert() {
			this.code.msg=""
			this.mobilephone.msg=""
			this.dataTransaksi.code=""
			this.transactionDetail.code=""
		},

		cekTransaksi() {
			if(validator.isEmpty(this.code.data)) {
				this.code.msg="Tidak boleh kosong"
			} else {
				this.code.msg =""
			}

			if(validator.isEmpty(this.mobilephone.data)) {
				this.mobilephone.msg ="Tidak boleh kosong"
			} else {
				this.mobilephone.msg=""
			}

			if(this.code.msg =="" && this.mobilephone.msg =="" ) {
				this.transactionDetail.code=""
				this.getTransactionDetail({"code" : this.code.data, "mobilephone" : this.mobilephone.data})
			}
		}
	},
	
	created(){
		this.$store.dispatch('setPageTitle', `Cek Transaksi`);
	}
}
</script>
